import outputTypes from '@/config/output-types';
import serviceTypes from '@/config/service-types';
import sourcesOfFunds from '@/config/sources-of-funds';
import tabs from '@/config/tabs';
import yearTypes from '@/config/year-types';

/**
 * Given a filters object representing current filters and a min and max year
 * representing the date range for which we have data, disambiguates filters
 * by replacing asterisks in filter configuration with actual years from data
 * and coded identifiers with human-readable strings.
 * @param {object} filters - The filters object to disambiguate.
 * @param {number} minYear - Optional. The minimum year to sub in.
 * @param {number} maxYear - Optional. The maximum year to sub in.
 * @returns {object} Disambiguated filters.
 */
const disambiguateFilters = (filters, minYear = 0, maxYear = 0) => ({
  outputType: outputTypes.find((outputType) => outputType.value === filters.outputType).label,
  serviceType: filters.serviceType.map((serviceType) => serviceTypes.get(serviceType)),
  sourceOfFunds: filters.sourceOfFunds.map((sourceOfFunds) => (
    sourceOfFunds === 'allSources' && filters.tab >= 2
      ? 'Total National Health Expenditures'
      : sourcesOfFunds.get(sourceOfFunds))),
  tab: tabs.get(filters.tab),
  yearCompare: [
    filters.yearCompare[0] === '*' ? minYear : filters.yearCompare[0],
    filters.yearCompare[1] === '*' ? maxYear : filters.yearCompare[1],
  ],
  yearRange: [
    filters.yearRange[0] === '*' ? minYear : filters.yearRange[0],
    filters.yearRange[1] === '*' ? maxYear : filters.yearRange[1],
  ],
  yearSingle: filters.yearSingle === '*' ? maxYear : filters.yearSingle,
  yearType: yearTypes.get(filters.yearType),
});

export default disambiguateFilters;
